import React from 'react';
import './ConfirmPassword.css';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Label,
    Input,
    Form,
} from 'reactstrap';

const ConfirmPassword = ({ modal, toggle, onConfirm, onInputChange }) => {
    return (
        <div>
            <Modal isOpen={modal} toggle={toggle} className={'confirm-password-modal'}>
                <ModalHeader toggle={toggle}>Please, enter a password</ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label for="examplePassword">Password</Label>
                        <Input
                            type="password"
                            onChange={onInputChange}
                            name="password"
                            id="examplePassword"
                            placeholder="Enter Password"
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={onConfirm}>
                        Confirm
                    </Button>{' '}
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ConfirmPassword;
